import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import { HeadingContextProvider } from "../context/HeadingContext";
import Error404 from "../pages/error/Error404";
import ShopDashboard from "../pages/shop/ShopDashboard";
import SchedulePage from "../pages/shop/Schedule/SchedulePage";
import OrderPickupHistoryPage from "../pages/shop/ReadyForPickup/OrderPickupHistory";
import NewPickupPage from "../pages/shop/ReadyForPickup/NewPickupPage";
import PickupDetailsPage from "../pages/shop/ReadyForPickup/PickupDetailsPage";
import ReadyForPickupPage from "../pages/shop/ReadyForPickup/ReadyForPickupPage";
import TimeApprovalsPage from "../pages/shop/Time/TimeApprovalsPage";
import TimeApprovalPage from "../pages/shop/Time/TimeApprovalPage";
import Settings from "../pages/customer/Settings/Settings";
import EditPickupPage from "../pages/shop/ReadyForPickup/EditPickupPage";
import CustomerReviewAndSignPickupPage from "../pages/shop/ReadyForPickup/CustomerReviewAndSignPickupPage";
import OrderDetailsPage from "../pages/shop/Orders/Order/OrderDetailsPage";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import ShopJobs from "../pages/shop/Jobs/ShopJobList";
import ShopJobsPage from "../pages/shop/Jobs/ShopJobsPage";

const ShopForemanRoutes = () => {
  return (
    <HeadingContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ShopDashboard />}>
            <Route path="/" element={<ShopJobsPage />} />
            <Route path="/jobs" element={<ShopJobsPage />} />
            <Route path="/shop-schedule" element={<SchedulePage />} />
            <Route path="job-pickups" element={<ReadyForPickupPage />} />
            <Route
              path="job-pickups/:orderId"
              element={<OrderPickupHistoryPage />}
            />
            <Route
              path="job-pickups/:orderId/new-pickup"
              element={<NewPickupPage />}
            />
            <Route
              path="job-pickups/:orderId/pickups/:pickupId"
              element={<PickupDetailsPage />}
            />
            <Route
              path="job-pickups/:orderId/pickups/:pickupId/edit"
              element={<EditPickupPage />}
            />
            <Route
              path="job-pickups/:orderId/pickups/:pickupId/review"
              element={<CustomerReviewAndSignPickupPage />}
            />

            {/* <Route
              path="/orders/:id"
              element={
                <MobileOrderContextProvider>
                  <Order />
                </MobileOrderContextProvider>
              }
            /> */}
            <Route path="/orders/:id" element={<OrderDetailsPage />} />

            <Route
              path="weekly-time-summaries"
              element={<TimeApprovalsPage />}
            />
            <Route
              path="weekly-time-summaries/:weeklyTimeSummaryId"
              element={<TimeApprovalPage />}
            />
            {/* No Auth Weekly Time Summary Signing Page */}
            <Route
              path="/weekly-time-summary/:weeklyTimeSummaryId"
              element={<TimeApprovalPage />}
            />

            {/* <Route path="settings" element={<Settings />} /> */}
            <Route path="*" element={<Error404 />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HeadingContextProvider>
  );
};
export default ShopForemanRoutes;
